import { Box } from '@mui/material';
import { gridDensitySelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';

export function LocationCell({ name, city, state }: { name: string; city: string; state: string }) {
  const apiRef = useGridApiContext();
  const density = useGridSelector(apiRef, gridDensitySelector);
  const isCompact = density === 'compact';
  const cityState = [city, state].filter(Boolean).join(', ');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', lineHeight: 1.2, minWidth: 0 }}>
      <Box
        component='span'
        sx={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {name}
      </Box>
      {!isCompact && cityState && (
        <Box
          component='span'
          sx={{ fontSize: '0.75rem', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {cityState}
        </Box>
      )}
    </Box>
  );
}
